import { Address } from '@ton/core/dist/address/Address';
import { getTonWeb } from '../../../config/ton';

export async function checkIsJettonWallet(jettonWalletAddress: string) {
  const TonWeb = await getTonWeb();
  const tonweb = new TonWeb(new TonWeb.HttpProvider());
  const jettonWallet = new TonWeb.token.jetton.JettonWallet(tonweb.provider, {
    address: jettonWalletAddress,
  } as any);
  try {
    const data = await jettonWallet.getData();
    const jettonMinterAddress = data.jettonMinterAddress.toString(
      true,
      true,
      true
    );
    console.log('Jetton Minter Address:', jettonMinterAddress);
    console.log('This address is a valid Jetton Wallet address.');
    return jettonMinterAddress;
  } catch (error) {
    console.error(error);
    console.log(`${jettonWalletAddress} doesn't seems to be a jetton`);
    return false;
  }
}

export function isJUSDT(address: string) {
  const usdtAddress = 'EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs';
  if (
    usdtAddress === address ||
    Address.parse(address).toString() ===
      Address.parse(usdtAddress).toString() ||
    Address.parse(usdtAddress).toString() === address ||
    Address.parse(address).toString() === usdtAddress
  ) {
    return true;
  } else {
    return false;
  }
}

export function roughlyGuessJettonDecimal(address: string) {
  return isJUSDT(address) ? 6 : 9;
}
